import React from 'react';
import PropTypes from 'prop-types';
import MembersApi from "../../../../../services/portal-api/MembersApi";
import { Link, Redirect } from 'react-router-dom';
import AuthService from '../../../../../services/AuthService';
import { FcVoicePresentation } from "react-icons/fc";

export default class UserTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            setting: {
                STORE_ADMIN_TIMEOUT: 0,
                SUPER_ADMIN_TIMEOUT: 0,
                STORE_USER_TIMEOUT: 0,
                CUST_ADMIN_TIMEOUT: 0,
                AREA_MANAGER_TIMEOUT: 0
            },
            errors: {},
            usernameSort: 'ASC',
            lastLoggedInSort: 'ASC',
        };
    }

    componentDidMount() {
        this._loadSettings();
    }

    _loadSettings = () => {
        MembersApi.getSettingsAll((response) => {
            if (response.success) {
                const { setting } = this.state;
                response.json.settings.forEach((v, k) => {
                    setting[v.setting_keys] = (v.setting_keys != undefined || v.setting_keys != '') ? v.setting_values : 0;
                });
                this.setState({
                    setting: setting
                });
            }
        });
    }

    handleUsernameSort = (column) => {  
        if(column == 'last_logged_in_time') {
            this.setState(prevState => ({
                lastLoggedInSort: prevState.lastLoggedInSort == 'ASC' ? 'DESC' : 'ASC'
                
            }), () => {
                console.log('lastLoggedInSort selected');
            })
        } 

        if(column == 'username') {
            this.setState(prevState => ({
                usernameSort: prevState.usernameSort == 'ASC' ? 'DESC' : 'ASC'
                
            }), () => {
                console.log('usernameSort selected');
            })
        }

        this.props.sort(column);
    }

    handleInputs = (id, type, usid) => {
        // if (window.confirm(`Do you really want to ${type} this user account ?`)) {
        //     MembersApi.delUser((response) => {
        //         if (response.success) {
        //             alert(response.json.message);
        //             // location.reload();
        //             if (type === 'Delete' || type === 'delete') {
        //                 this.props.removeUser(id);
        //             } else {
        //                 this.props.updateIsActive();
        //             }
        //         } else {
        //             this.props.sessionLog(response);
        //         }
        //     }, id, type, usid);
        // }

        swal({
            title: "Are you sure?",
            text: "you really want to " + type + " this user account?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    const handleButtonClick = (response) => {
                        if (response.success) {
                            if (type == 'Delete' || type == 'delete') {
                                this.props.removeUser(id);
                            } else {
                                this.props.updateIsActive();
                            }

                            swal(response.json.message, {
                                icon: "success",
                                buttons: false,
                                timer: 3000
                            });
                        } else {
                            this.props.sessionLog(response);
                        }
                    }

                    MembersApi.delUser(handleButtonClick, id, type, usid);

                } else {
                    swal(`You have cancelled the ${type} action`, {
                        buttons: false,
                        timer: 2000
                    });
                }
            });
    }

    _defaultSettings = (admin, setting) => {

        switch (admin) {
            case 0:
                return setting.STORE_USER_TIMEOUT;
                break;
            case 1:
                return setting.SUPER_ADMIN_TIMEOUT;
                break;
            case 2:
                return setting.STORE_ADMIN_TIMEOUT;
                break;
            case 3:
                return setting.CUST_ADMIN_TIMEOUT;
                break;
            case 4:
                return setting.AREA_MANAGER_TIMEOUT;
                break;
            default:
                return 0;
                break;
        };
    }

    render() {
        //if (this.props.stores.length === 0) {
        //    return null;
        //}

        // Build table rows
        const rows = []; let k = 0
        const { setting } = this.state;
        this.props.users.forEach((user, index) => {

            if (!AuthService.isAdmin() && user.is_admin == 1) {
                return;
            } else if (!AuthService.isAdmin() && AuthService.getAdminType() == 3 && user.is_admin == 2) {
                return;
            } else if (!AuthService.isAdmin() && AuthService.getAdminType() == 2 && user.is_admin == 3) {
                return;
            }

            let setto = 0;
            setto = this._defaultSettings(user.is_admin, setting);

            function icon() {
                return <small><FcVoicePresentation /></small>
            }

            rows.push(
                <tr key={index}>
                    <td style={{ overflowWrap: 'anywhere' }}><strong>{user.uname}</strong> &nbsp; {user.multipleStore ? icon() : null}</td>
                    <td><strong>{user.is_admin == 1 ? 'Super Admin' : (user.is_admin == 2 ? 'Store Admin' : (user.is_admin == 3 ? 'CS Admin' : 'Store User'))}</strong></td>
                    <td><strong>{user.timeout_period == 0 ? (user.is_global == 0 ? "Unlimited" : (setto == 0 ? "Global (Unlimited)" : `Global (${setto} Mins)`)) : user.timeout_period + " min"}</strong></td>
                    <td><strong>{user.formated_date_created}</strong></td>
                    <td><strong>{user.formated_last_logged_in}</strong></td>
                    <td>
                        <table style={{ marginTop: 0 }}>
                            <tbody>
                                <tr>
                                    {AuthService.can('edit store users') &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <Link to={{ 'pathname': '/user/' + user.uid + '/edit/' + user.uname, 'state': { 'prevPath': location.pathname } }} className="btn btn--xsmall btn--color btn--open">Edit <img className="icon" src="/img/icon-arrowOpen--white.svg" width="10" height="10" /></Link>
                                        </td>
                                    }
                                    {(AuthService.getAdminType() == 1 || (AuthService.getAdminType() == 2 && AuthService.can('delete store users'))) &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a href="javascript:void(0)" className="btn btn--xsmall btn--red" onClick={this.handleInputs.bind(this, user.uid, "Delete", user.usid)} >Remove</a>
                                        </td>
                                    }
                                    {AuthService.getAdminType() == 1 && AuthService.can('Activate/Deactivate users') &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a href="javascript:void(0)" className={user.is_active == 1 ? "btn btn--xsmall" : "btn btn--xsmall btn--blue"} style={{ paddingLeft: user.is_active == 1 ? "" : 28, paddingRight: user.is_active == 1 ? "" : 28 }} onClick={this.handleInputs.bind(this, user.uid, user.is_active == 1 ? "Deactivate" : "Activate", user.usid)} >{user.is_active == 1 ? "Deactivate" : "Activate"}</a>
                                        </td>
                                    }
                                    {AuthService.getAdminType() == 2 && AuthService.can('Activate/Deactivate store users') &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a href="javascript:void(0)" className={user.is_active == 1 ? "btn btn--xsmall" : "btn btn--xsmall btn--blue"} style={{ paddingLeft: user.is_active == 1 ? "" : 28, paddingRight: user.is_active == 1 ? "" : 28 }} onClick={this.handleInputs.bind(this, user.uid, user.is_active == 1 ? "Deactivate" : "Activate", user.usid)} >{user.is_active == 1 ? "Deactivate" : "Activate"}</a>
                                        </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            );
        });

        return (
            (AuthService.getAdminType() == 1 || AuthService.getAdminType() == 2) && AuthService.can('store users') &&
            <div className="container">
                <h2 className="text--light text--color text--40">User Accounts ({this.props.storeName})</h2>
                <div className="table--overflow clearfix margin--30--top" style={{ overflow: "auto" }}>
                    <div><FcVoicePresentation /> &nbsp; <small>Multi Store User</small></div>
                    <table>
                        <thead>
                            <tr>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', width: '18%' }}>
                                    Username
                                    &nbsp;
                                        {this.state.usernameSort === 'ASC' && <span onClick={() => this.handleUsernameSort('username')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&uarr;</b></span>}
                                        {this.state.usernameSort === 'DESC' && <span onClick={() => this.handleUsernameSort('username')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&darr;</b></span>}
                                </th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', width: '18%' }}>User Type</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', width: '18%' }}>Timeout</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle' }}>Created On</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
                                    Last Logged In &nbsp;
                                    {this.state.lastLoggedInSort === 'ASC' && <span onClick={() => this.handleUsernameSort('last_logged_in_time')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&uarr;</b></span>}
                                    {this.state.lastLoggedInSort === 'DESC' && <span onClick={() => this.handleUsernameSort('last_logged_in_time')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&darr;</b></span>}
                                </th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', textAlign: 'center' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                            {this.props.users.length === 0 &&
                                <tr>
                                    <td colSpan="7">No results founds.</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

UserTable.propTypes = {
    users: PropTypes.array.isRequired
};
